import React from 'react';

interface IIcone {
  tam?: number;
  cor?: string;
  traco?: number;
}

const Svg = ({
  tam = 16,
  cor = 'currentColor',
  traco = 2.2,
  children,
  className,
}: IIcone & { children: React.ReactNode; className?: string }) => (
  <svg
    className={className}
    width={tam}
    height={tam}
    viewBox="0 0 24 24"
    fill="none"
    stroke={cor}
    strokeWidth={traco}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {children}
  </svg>
);

export const Voltar = (p: IIcone) => (
  <Svg {...p}>
    <path d="M19 12H5M12 19l-7-7 7-7" />
  </Svg>
);
export const Anterior = (p: IIcone) => (
  <Svg {...p}>
    <path d="M15 18l-6-6 6-6" />
  </Svg>
);
export const Proximo = (p: IIcone) => (
  <Svg {...p}>
    <path d="M9 18l6-6-6-6" />
  </Svg>
);
export const Check = (p: IIcone) => (
  <Svg {...p}>
    <path d="M20 6L9 17l-5-5" />
  </Svg>
);
export const SetaBaixo = (p: IIcone & { className?: string }) => (
  <Svg {...p}>
    <path d="M6 9l6 6 6-6" />
  </Svg>
);
export const Funil = (p: IIcone) => (
  <Svg {...p}>
    <path d="M3 5h18l-7 8v6l-4 2v-8z" />
  </Svg>
);
export const Calendario = (p: IIcone) => (
  <Svg {...p}>
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M16 3v4M8 3v4M3 10h18" />
  </Svg>
);
export const Lua = (p: IIcone) => (
  <Svg {...p}>
    <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
  </Svg>
);
export const Sol = (p: IIcone) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
  </Svg>
);

/** Caixinha de marcar dos grupos do calendário. */
export const Caixa = ({ ativo, cor }: { ativo: boolean; cor: string }) => (
  <span
    aria-hidden="true"
    style={{
      width: 16,
      height: 16,
      boxSizing: 'border-box',
      flexShrink: 0,
      borderRadius: 4,
      border: `1.5px solid ${ativo ? cor : '#CBD5E1'}`,
      background: ativo ? cor : '#FFFFFF',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Check tam={11} cor="#FFFFFF" traco={3.2} />
  </span>
);

/** Trilhas de circuito discretas das laterais do fundo (cor no CSS: `.circuito`). */
export const Circuito = () => (
  <>
    <svg className="circuito esq" aria-hidden="true" width="300" height="100%">
      <defs>
        <pattern id="fcmTrilhaCircuito" width="300" height="420" patternUnits="userSpaceOnUse">
          <g
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M0 30H60l20 20h70l20 20h30M0 62H40l18 18v58l20 20h40M0 112H22l14 14v92l20 20h112l20-20h40M0 270H70l20-20h50M0 300H30l20 20v58l20 20h40l20-20h50M0 342H92l18 18h40M240 0v100l-20 20v70M210 420v-90l20-20v-28" />
            <rect x="154" y="118" width="36" height="36" rx="4" />
            <path d="M154 126h-10M154 136h-10M154 146h-10M190 126h10M190 136h10M190 146h10" />
          </g>
          <g className="circuitoNo" stroke="currentColor" strokeWidth="1.6">
            {[
              [200, 70, 3.5],
              [118, 158, 3.5],
              [228, 218, 3.5],
              [140, 250, 3.5],
              [180, 378, 3.5],
              [150, 360, 3.5],
              [220, 190, 3.5],
              [230, 282, 3.5],
              [36, 170, 2.5],
              [58, 108, 2.5],
            ].map(([cx, cy, r]) => (
              <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r={r} />
            ))}
          </g>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#fcmTrilhaCircuito)" />
    </svg>
    <svg className="circuito dir" aria-hidden="true" width="300" height="100%">
      <rect width="100%" height="100%" fill="url(#fcmTrilhaCircuito)" />
    </svg>
  </>
);
export const Baixar = (p: IIcone) => (
  <Svg {...p}>
    <path d="M12 4v11M7 10l5 5 5-5M5 20h14" />
  </Svg>
);
